import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=95f56456&scoped=true"
import script from "./Confirm.vue?vue&type=script&lang=js"
export * from "./Confirm.vue?vue&type=script&lang=js"
import style0 from "./Confirm.vue?vue&type=style&index=0&id=95f56456&lang=scss&scoped=true"
import style1 from "./Confirm.vue?vue&type=style&index=1&id=95f56456&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f56456",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95f56456')) {
      api.createRecord('95f56456', component.options)
    } else {
      api.reload('95f56456', component.options)
    }
    module.hot.accept("./Confirm.vue?vue&type=template&id=95f56456&scoped=true", function () {
      api.rerender('95f56456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/assurance/components/dialogs/Confirm.vue"
export default component.exports